
class WdTradeInPopup extends HTMLElement {

    constructor() {
        super();
        this.tradeInProducts = [];
        this.tradeInProductsLoaded = false;
        this.uniqueBrands = [];

        // Fixed condition options
        this.conditionOptions = ["תקין פלוס", "תקין בעל מסך מקורי", "תקין בעל מסך לא מקורי / מקורי שרוט", "תקול"];
        this.tradeInPerfectConditionDescription = window.tradeInPopupConfig.tradeInPerfectConditionDescription;
        this.tradeInGoodConditionDescription = window.tradeInPopupConfig.tradeInGoodConditionDescription;
        this.tradeInPoorConditionDescription = window.tradeInPopupConfig.tradeInPoorConditionDescription;
        this.tradeInNotOriginalConditionDescription = window.tradeInPopupConfig.tradeInNotOriginalConditionDescription;

        // Selected values
        this.selectedBrand = '';
        this.selectedModel = '';
        this.selectedCapacity = '';
        this.selectedCondition = '';

        // Modal ID
        this.modalId = 'wd-trade-in-popup-modal';

        // Store matched product (not set to window until button is clicked)
        this.matchedProduct = null;
        this.readyPromise = new Promise((resolve) => { this._resolveReady = resolve; });

        // Initialize window variables - but preserve existing values if they're set (for cart edit mode)
        // Don't overwrite window.tradeInProductToAdd if it's already set (e.g., from cart edit)
        if (typeof window.tradeInProductToAdd === 'undefined') {
            window.tradeInProductToAdd = null;
        }
        // Only reset isAddtradeInProduct if it's not already set
        if (typeof window.isAddtradeInProduct === 'undefined') {
            window.isAddtradeInProduct = false;
        }
    }

    /** @returns {Promise<void>} */
    whenReady() { return this.readyPromise; }

    async connectedCallback() {
        await this.loadTradeInProducts();

        // Automatically called when element is added to DOM
        // Check if modal already exists in DOM (from previous session)
        const existingModal = document.getElementById(this.modalId);
        if (existingModal) {
            // Modal exists, just set it up
            this.createModal();
        } else {
            // Modal doesn't exist, create it
            this.createModal();
            // Only show modal if it's a new creation (not from cart edit)
            // Cart edit will trigger showModal separately
            if (!window.tradeInCartContext) {
                this.showModal();
            }
        }
        this._resolveReady?.();
    }

    async loadTradeInProducts() {
        if (this.tradeInProductsLoaded) return;

        const data = await window.wdFetchTradeInCollectionData();
        this.tradeInProducts = (data.products ?? []).map(p => ({
            ...p,
            tradeInCondition: this.normalizeCondition(p.tradeInCondition)
        }));
        this.uniqueBrands = [...new Set(this.tradeInProducts.map(p => p.brand))];
        this.tradeInProductsLoaded = true;
    }

    normalizeCondition(condition) {
        if (condition === "תקין") return "תקין בעל מסך מקורי";
        if (condition === "לא מקורי" || condition === "תקין לא מקורי") return "תקין בעל מסך לא מקורי / מקורי שרוט";
        return condition;
    }

    createModal() {
        // Check if modal already exists
        if (document.getElementById(this.modalId)) {
            console.log('Modal already exists');

            // Reset all selects first
            const brandSelect = document.getElementById('wd-trade-in-brand-select');
            const modelSelect = document.getElementById('wd-trade-in-model-select');
            const capacitySelect = document.getElementById('wd-trade-in-capacity-select');

            // Clear and reset selects
            if (modelSelect) {
                this.clearSelect(modelSelect);
                modelSelect.disabled = true;
                modelSelect.value = '';
            }
            if (capacitySelect) {
                this.clearSelect(capacitySelect);
                capacitySelect.disabled = true;
                capacitySelect.value = '';
            }
            this.disableConditions();
            this.hideValueDisplay();
            this.hideAddButton();

            // Reset selected values
            this.selectedBrand = '';
            this.selectedModel = '';
            this.selectedCapacity = '';
            this.selectedCondition = '';
            this.matchedProduct = null;

            // Ensure brand select is populated
            this.populateBrandSelect();

            // Set up event listeners (only if not already set up)
            if (brandSelect && !brandSelect.hasAttribute('data-listeners-attached')) {
                this.setupEventListeners();
                brandSelect.setAttribute('data-listeners-attached', 'true');
            }

            if (window.tradeInProductToAdd) {
                // Small delay to ensure DOM is ready and brand select is populated, then load the product
                setTimeout(() => {
                    this.loadExistingProduct(window.tradeInProductToAdd);
                }, 300);
            }
            return;
        }


        // Create modal structure with trigger button
        const modalContainer = document.createElement('div');
        modalContainer.className = 'seedkit-component-standalone';
        modalContainer.innerHTML = `
                <button
                    class="ac-modal-trigger"
                    data-modal-target="${this.modalId}"
                    style="display: none;"
                    aria-hidden="true"
                ></button>
                <div
                    id="${this.modalId}"
                    class="ac-modal wd-trade-in-popup-modal"
                    data-type="content"
                    data-width="wide"
                    data-variant="pageOverlay"
                    data-modal-dialog-label="Trade-In Popup"
                    data-modal-close-label="סגור מודל"
                >
                    <div class="trade-in__modal-content wd-trade-in-popup-modal-content">
                        <h2 class="title">החלף את המכשיר שלך</h2>
                        
                        <label class="select-label" for="wd-trade-in-brand-select">
                            בחר מותג
                        </label>
                        <div class="trade-in__modal-content-select">
                            <select
                                class="select"
                                id="wd-trade-in-brand-select"
                                name="wd-trade-in-brand-select"
                            >
                                <option value="">בחר מותג</option>
                            </select>
                        </div>

                        <label class="select-label" for="wd-trade-in-model-select">
                            בחר דגם
                        </label>
                        <div class="trade-in__modal-content-select">
                            <select
                                class="select"
                                id="wd-trade-in-model-select"
                                name="wd-trade-in-model-select"
                                disabled
                            >
                                <option value="">בחר דגם</option>
                            </select>
                        </div>

                        <label class="select-label" for="wd-trade-in-capacity-select">
                            בחר נפח
                        </label>
                        <div class="trade-in__modal-content-select">
                            <select
                                class="select"
                                id="wd-trade-in-capacity-select"
                                name="wd-trade-in-capacity-select"
                                disabled
                            >
                                <option value="">בחר נפח</option>
                            </select>
                        </div>

                        <fieldset class="radio-options-container" id="wd-trade-in-conditions-container">
                            <legend class="radio-options-label">ספר לנו על המכשיר שלך</legend>
                            ${this.conditionOptions.map((condition, index) => `
                                <div class="radio">
                                    <input
                                        type="radio"
                                        id="wd-trade-in-condition-${index}"
                                        name="wd-trade-in-condition"
                                        value="${condition}"
                                        disabled
                                    >
                                    <label for="wd-trade-in-condition-${index}">${condition}
                                    
                                    ${condition === "תקין פלוס" ? this.tradeInPerfectConditionDescription : condition === "תקין בעל מסך מקורי" ? this.tradeInGoodConditionDescription : condition === "תקין בעל מסך לא מקורי / מקורי שרוט" ? this.tradeInNotOriginalConditionDescription : this.tradeInPoorConditionDescription}
                                    </label>
                                </div>
                            `).join('')}
                        </fieldset>

                        <div id="wd-trade-in-value-display" class="value-description" style="display: none;">
                            <h3 class="value-title" tabindex="0" aria-label="ערך הטרייד-אין שלך">ערך הטרייד-אין שלך</h3>
                            <p>
                                עד <span class="value-amount js-trade-in-value-amount" id="wd-trade-in-value-amount">₪0</span>
                            </p>
                        </div>

                        <div id="wd-trade-in-not-valid-trade-in" class="value-description" style="display: none;">
                            <h3 class="value-title" tabindex="0" aria-label="המכשיר שלך אינו זמין לטרייד-אין כרגע">המכשיר שלך אינו זמין לטרייד-אין כרגע</h3>
                        </div>

                        <button
                            id="wd-trade-in-add-btn"
                            tabindex="0"
                            aria-label="הוסף trade-in"
                            class="button button--full-width button--primary"
                            style="display: none; margin-top: 20px;"
                        >
                            הוסף trade-in
                        </button>
                    </div>
                </div>
            `;

        // Append to body
        document.body.appendChild(modalContainer);

        // Refresh modals to initialize the new modal with ac-modal system
        if (typeof window.refreshModals === 'function') {
            window.refreshModals();
        }

        // Populate brand select
        this.populateBrandSelect();

        // Set up event listeners
        this.setupEventListeners();

        // Check if we're in edit mode (window.tradeInProductToAdd is already set)
        // Wait a bit for modal to be fully initialized before loading product
        if (window.tradeInProductToAdd) {
            setTimeout(() => {
                this.loadExistingProduct(window.tradeInProductToAdd);
            }, 400);
        }

    }

    populateBrandSelect() {
        const brandSelect = document.getElementById('wd-trade-in-brand-select');
        if (!brandSelect) return;

        this.uniqueBrands.forEach(brand => {
            const option = document.createElement('option');
            option.value = brand;
            option.textContent = brand;
            brandSelect.appendChild(option);
        });
    }

    setupEventListeners() {
        const brandSelect = document.getElementById('wd-trade-in-brand-select');
        const modelSelect = document.getElementById('wd-trade-in-model-select');
        const capacitySelect = document.getElementById('wd-trade-in-capacity-select');
        const conditionRadios = document.querySelectorAll('input[name="wd-trade-in-condition"]');

        // Brand select change
        if (brandSelect) {
            brandSelect.addEventListener('change', (e) => {
                this.selectedBrand = e.target.value;
                this.selectedModel = '';
                this.selectedCapacity = '';
                this.selectedCondition = '';
                window.tradeInProductToAdd = null;
                window.isAddtradeInProduct = false;

                // Reset model select UI
                this.clearSelect(modelSelect);
                modelSelect.value = '';
                modelSelect.disabled = true;

                // Reset capacity select UI
                this.clearSelect(capacitySelect);
                capacitySelect.value = '';
                capacitySelect.disabled = true;

                // Reset conditions
                this.disableConditions();
                this.hideValueDisplay();
                this.hideAddButton();
                this.matchedProduct = null;

                if (this.selectedBrand) {
                    this.populateModelSelect();
                    modelSelect.disabled = false;
                }
            });
        }

        // Model select change
        if (modelSelect) {
            modelSelect.addEventListener('change', (e) => {
                this.selectedModel = e.target.value;
                this.selectedCapacity = '';
                this.selectedCondition = '';
                window.tradeInProductToAdd = null;
                window.isAddtradeInProduct = false;
                this.matchedProduct = null;

                // Reset capacity select UI
                this.clearSelect(capacitySelect);
                capacitySelect.value = '';
                capacitySelect.disabled = true;

                // Reset conditions
                this.disableConditions();
                this.hideValueDisplay();
                this.hideAddButton();

                if (this.selectedModel) {
                    this.populateCapacitySelect();
                    capacitySelect.disabled = false;
                }
            });
        }

        // Capacity select change
        if (capacitySelect) {
            capacitySelect.addEventListener('change', (e) => {
                const previousCondition = this.selectedCondition;
                this.selectedCapacity = e.target.value;
                this.selectedCondition = '';
                window.tradeInProductToAdd = null;
                window.isAddtradeInProduct = false;
                this.matchedProduct = null;

                // Reset conditions UI but preserve previous selection if capacity is still valid
                this.disableConditions();
                this.hideValueDisplay();
                this.hideAddButton();

                if (this.selectedCapacity) {
                    this.enableConditions();
                    // If a condition was previously selected, try to restore it and filter
                    if (previousCondition) {
                        const conditionRadio = Array.from(document.querySelectorAll('input[name="wd-trade-in-condition"]'))
                            .find(r => r.value === previousCondition);
                        if (conditionRadio) {
                            conditionRadio.checked = true;
                            this.selectedCondition = previousCondition;
                            this.checkAndUpdateProduct();
                        }
                    }
                }
            });
        }

        // Condition radio change (native group: one tab stop, arrow keys move between options)
        conditionRadios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.selectedCondition = e.target.value;
                    this.checkAndUpdateProduct();
                }
            });
        });

        // Add button click handler
        const addButton = document.getElementById('wd-trade-in-add-btn');
        if (addButton) {
            addButton.addEventListener('click', async () => {
                if (this.matchedProduct) {
                    // Check if we're in cart context
                    if (window.tradeInCartContext) {
                        // Dispatch custom event to notify cart component
                        window.dispatchEvent(new CustomEvent('tradeInProductChanged', {
                            detail: { product: this.matchedProduct }
                        }));
                    } else {
                        // PDP context - use existing flow
                        window.tradeInProductToAdd = this.matchedProduct;
                        window.isAddtradeInProduct = true;

                        // Dispatch custom event to notify other components
                        window.dispatchEvent(new CustomEvent('tradeInProductChanged', {
                            detail: { product: this.matchedProduct }
                        }));
                    }

                    // Close modal after adding
                    const modal = document.getElementById(this.modalId);
                    if (modal) {
                        // Find the modal root and close button
                        const modalRoot = modal.closest('.modal');
                        if (modalRoot) {
                            // Look for close button - it's typically a sibling or child
                            const closeButton = modalRoot.querySelector('.modal-close-button') ||
                                modalRoot.nextElementSibling?.querySelector('.modal-close-button') ||
                                document.querySelector(`[aria-label*="Close"], [aria-label*="close"]`);
                            if (closeButton) {
                                closeButton.click();
                            } else {
                                // Fallback: remove modal-open class from body
                                document.body.classList.remove('modal-open');
                                if (modalRoot) {
                                    modalRoot.classList.remove('modal-open');
                                }
                            }
                        }
                    }
                }
            });
        }
    }

    populateModelSelect() {
        const modelSelect = document.getElementById('wd-trade-in-model-select');
        if (!modelSelect) return;

        this.clearSelect(modelSelect);

        // Filter models by selected brand
        const availableModels = [...new Set(
            this.tradeInProducts
                .filter(p => p.brand === this.selectedBrand)
                .map(p => p.tradeInModel)
                .filter(model => model) // Remove null/undefined
        )];

        availableModels.sort((a, b) => this.compareModelsHighToLow(a, b));

        availableModels.forEach(model => {
            const option = document.createElement('option');
            option.value = model;
            option.textContent = model;
            modelSelect.appendChild(option);
        });
    }

    // Sort by letters and numbers high → low (e.g. 17 before 16, Pro Max before Pro, Se/Air before numbered)
    compareModelsHighToLow(a, b) {
        const typeRank = { letter: 2, number: 1, symbol: 0 };
        const aTokens = this.parseModelTokens(a);
        const bTokens = this.parseModelTokens(b);
        const length = Math.max(aTokens.length, bTokens.length);

        for (let i = 0; i < length; i++) {
            const aToken = aTokens[i];
            const bToken = bTokens[i];
            if (!aToken) return 1;
            if (!bToken) return -1;
            if (aToken.type !== bToken.type) return typeRank[bToken.type] - typeRank[aToken.type];
            if (aToken.type === 'number') {
                if (aToken.value !== bToken.value) return bToken.value - aToken.value;
            } else if (aToken.value !== bToken.value) {
                return bToken.value.localeCompare(aToken.value);
            }
        }

        return 0;
    }

    parseModelTokens(name) {
        const tokens = [];
        const tokenPattern = /([A-Za-z]+)|(\d+)|(\+)|([^A-Za-z\d\s]+)/g;
        let match;

        while ((match = tokenPattern.exec(name))) {
            if (match[1]) tokens.push({ type: 'letter', value: match[1].toLowerCase() });
            else if (match[2]) tokens.push({ type: 'number', value: parseInt(match[2], 10) });
            else if (match[3]) tokens.push({ type: 'letter', value: 'plus' });
            else if (match[4]) tokens.push({ type: 'symbol', value: match[4] });
        }

        return tokens;
    }

    populateCapacitySelect() {
        const capacitySelect = document.getElementById('wd-trade-in-capacity-select');
        if (!capacitySelect) return;

        this.clearSelect(capacitySelect);

        // Filter capacities by selected brand and model
        const availableCapacities = [...new Set(
            this.tradeInProducts
                .filter(p => p.brand === this.selectedBrand && p.tradeInModel === this.selectedModel)
                .map(p => p.tradeInCapacity)
                .filter(capacity => capacity) // Remove null/undefined
        )];

        availableCapacities.forEach(capacity => {
            const option = document.createElement('option');
            option.value = capacity;
            option.textContent = capacity;
            capacitySelect.appendChild(option);
        });
    }

    enableConditions() {
        const conditionRadios = document.querySelectorAll('input[name="wd-trade-in-condition"]');
        conditionRadios.forEach(radio => {
            radio.disabled = false;
        });
    }

    disableConditions() {
        const conditionRadios = document.querySelectorAll('input[name="wd-trade-in-condition"]');
        conditionRadios.forEach(radio => {
            radio.disabled = true;
            radio.checked = false;
        });
    }

    filterAndSetProduct() {
        // Check if all four filters are selected
        if (!this.selectedBrand || !this.selectedModel || !this.selectedCapacity || !this.selectedCondition) {
            this.matchedProduct = null;
            window.tradeInProductToAdd = null;
            window.isAddtradeInProduct = false;
            this.hideValueDisplay();
            this.hideAddButton();
            return;
        }

        // Filter products based on all criteria
        const matchingProducts = this.tradeInProducts.filter(product => {
            return product.brand === this.selectedBrand &&
                product.tradeInModel === this.selectedModel &&
                product.tradeInCapacity === this.selectedCapacity &&
                product.tradeInCondition === this.selectedCondition;
        });
        if (matchingProducts.length === 1) {
            this.matchedProduct = matchingProducts[0];
            this.showValueDisplay(matchingProducts[0].price);
            this.hideNotValidTradeIn();
            this.showAddButton();
        } else if (matchingProducts.length > 1) {
            // If multiple matches, use the first one
            this.matchedProduct = matchingProducts[0];
            this.showValueDisplay(matchingProducts[0].price);
            this.hideNotValidTradeIn();
            this.showAddButton();
        } else {
            this.matchedProduct = null;
            window.tradeInProductToAdd = null;
            window.isAddtradeInProduct = false;
            this.hideValueDisplay();
            this.hideAddButton();
            //show user this trade in is not valid
            this.showNotValidTradeIn();
        }
    }

    // Check and update product when any filter changes (if all are selected)
    checkAndUpdateProduct() {
        // If all four filters are selected, try to filter and update
        if (this.selectedBrand && this.selectedModel && this.selectedCapacity && this.selectedCondition) {
            this.filterAndSetProduct();
        }
    }

    showValueDisplay(price) {
        const valueDisplay = document.getElementById('wd-trade-in-value-display');
        const valueAmount = document.getElementById('wd-trade-in-value-amount');

        if (valueDisplay && valueAmount) {
            // Convert price from cents to shekels and format
            const priceInShekels = (price / 100).toFixed(0);
            valueAmount.textContent = `₪${priceInShekels}`;
            valueDisplay.style.display = 'block';
        }
    }

    hideValueDisplay() {
        const valueDisplay = document.getElementById('wd-trade-in-value-display');
        if (valueDisplay) {
            valueDisplay.style.display = 'none';
        }
    }

    showNotValidTradeIn() {
        const notValidTradeIn = document.getElementById('wd-trade-in-not-valid-trade-in');
        if (notValidTradeIn) {
            notValidTradeIn.style.display = 'block';
        }
    }

    hideNotValidTradeIn() {
        const notValidTradeIn = document.getElementById('wd-trade-in-not-valid-trade-in');
        if (notValidTradeIn) {
            notValidTradeIn.style.display = 'none';
        }
    }

    showAddButton() {
        const addButton = document.getElementById('wd-trade-in-add-btn');
        if (addButton) {
            addButton.style.display = 'block';
        }
    }

    hideAddButton() {
        const addButton = document.getElementById('wd-trade-in-add-btn');
        if (addButton) {
            addButton.style.display = 'none';
        }
    }

    clearSelect(selectElement) {
        if (!selectElement) return;
        // Keep the first option (placeholder)
        while (selectElement.options.length > 1) {
            selectElement.remove(1);
        }
        selectElement.value = '';
    }

    loadExistingProduct(product) {
        console.log('Loading existing product:', product);

        // Set the matched product
        this.matchedProduct = product;

        // Extract values from product
        const brand = product.brand;
        const model = product.tradeInModel;
        const capacity = product.tradeInCapacity;
        const condition = this.normalizeCondition(product.tradeInCondition);

        // Set selected values
        this.selectedBrand = brand;
        this.selectedModel = model;
        this.selectedCapacity = capacity;
        this.selectedCondition = condition;

        // Get DOM elements
        const brandSelect = document.getElementById('wd-trade-in-brand-select');
        const modelSelect = document.getElementById('wd-trade-in-model-select');
        const capacitySelect = document.getElementById('wd-trade-in-capacity-select');
        const conditionRadios = document.querySelectorAll('input[name="wd-trade-in-condition"]');

        if (!brandSelect) {
            console.error('Brand select not found');
            return;
        }

        // Ensure brand select has options populated
        if (brandSelect.options.length <= 1) {
            this.populateBrandSelect();
        }

        // Select brand
        if (brand && brandSelect) {
            // Check if brand option exists
            const brandOption = Array.from(brandSelect.options).find(opt => opt.value === brand);
            if (!brandOption) {
                console.error('Brand option not found:', brand);
                return;
            }

            brandSelect.value = brand;
            this.selectedBrand = brand;

            // Populate and enable model select
            this.populateModelSelect();
            if (modelSelect) {
                modelSelect.disabled = false;
            }

            // Select model
            if (modelSelect && model) {
                // Wait a bit for options to be populated
                setTimeout(() => {
                    // Check if model option exists
                    const modelOption = Array.from(modelSelect.options).find(opt => opt.value === model);
                    if (modelOption) {
                        modelSelect.value = model;
                        this.selectedModel = model;

                        // Populate and enable capacity select
                        this.populateCapacitySelect();
                        if (capacitySelect) {
                            capacitySelect.disabled = false;
                        }

                        // Select capacity
                        if (capacitySelect && capacity) {
                            // Wait a bit for options to be populated
                            setTimeout(() => {
                                // Check if capacity option exists
                                const capacityOption = Array.from(capacitySelect.options).find(opt => opt.value === capacity);
                                if (capacityOption) {
                                    capacitySelect.value = capacity;
                                    this.selectedCapacity = capacity;

                                    // Enable conditions
                                    this.enableConditions();

                                    // Select condition
                                    if (conditionRadios.length && condition) {
                                        conditionRadios.forEach(radio => {
                                            if (radio.value === condition) {
                                                radio.checked = true;
                                                this.selectedCondition = condition;
                                            }
                                        });

                                        // Show value display and button
                                        this.showValueDisplay(product.price);
                                        this.showAddButton();
                                    }
                                } else {
                                    console.error('Capacity option not found:', capacity);
                                }
                            }, 150);
                        }
                    } else {
                        console.error('Model option not found:', model);
                    }
                }, 150);
            }
        }
    }

    showModal() {
        // Wait for modal to be created and ac-modal system to initialize
        const tryShowModal = () => {
            const modal = document.getElementById(this.modalId);
            const trigger = document.querySelector(`[data-modal-target="${this.modalId}"]`);


            if (!modal || !trigger) {
                setTimeout(tryShowModal, 50);
                return;
            }


            // Try to click the trigger - ac-modal system should handle it
            // Give it a moment for refreshModals to complete
            setTimeout(() => {
                try {
                    trigger.click();

                    // Check if modal opened
                    setTimeout(() => {
                        const modalRoot = modal.closest('.modal');
                        const isOpen = modalRoot && modalRoot.classList.contains('modal-open');

                        if (!isOpen) {
                            // Try one more time
                            setTimeout(() => trigger.click(), 200);
                        }
                    }, 300);
                } catch (e) {
                    console.error('Error triggering modal:', e);
                }
            }, 200);
        };

        // Start trying to show modal after a short delay to allow refreshModals to complete
        setTimeout(tryShowModal, 300);
    }
}

/** Trade-in cart row skeleton — loading keys survive section re-renders until priority cart sync. */
window.wdTradeInCartLoading = window.wdTradeInCartLoading || {};

if (!window._wdTradeInCartSkeletonListenersBound) {
    window._wdTradeInCartSkeletonListenersBound = true;

    window.addEventListener('tradeInCartUpdating', (event) => {
        const lineItemKey = event.detail?.lineItemKey;
        if (!lineItemKey) return;

        window.wdTradeInCartLoading[lineItemKey] = true;
        lineItemKey && [...document.querySelectorAll('wd-trade-in-cart')].filter(
            (el) => el.dataset.lineItemKey === lineItemKey
        ).forEach((el) => {
            if (typeof el.syncSkeletonState === 'function') el.syncSkeletonState();
        });
    });

    let timeout;
    window.addEventListener('wd:cart:updated', () => {
        window.wdSuppressBundleEnforcer = false;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            window.wdTradeInCartLoading = {};
            document.querySelectorAll('wd-trade-in-cart').forEach((el) => {
                if (typeof el.syncSkeletonState === 'function') el.syncSkeletonState();
            });
        }, 1000);
    });
}

// Define the custom element - connectedCallback will be called automatically when element is added to DOM
customElements.define('wd-trade-in-popup', WdTradeInPopup);
